<form class="mt-4" *ngIf="user" [formGroup]="accountForm" (ngSubmit)="save()">
  <div class="row mb-3 g-2">
    <div class="col">
      <input id="firstName" type="text" class="form-control" formControlName="firstName"
             placeholder="First Name">
      <ua-display-validation-errors name='First name' [control]="accountForm.controls.firstName"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
    <div class="col">
      <input id="lastName" type="text" class="form-control" formControlName="lastName"
             placeholder="Last Name">
      <ua-display-validation-errors name='Last name' [control]="accountForm.controls.lastName"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
  </div>

  <div class="mb-3">
    <input id="phoneNumber" type="tel" class="form-control" formControlName="phoneNumber"
           placeholder="Phone Number">
    <ua-display-validation-errors name='Phone number' [control]="accountForm.controls.phoneNumber"
                                  [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="mb-3">
    <input id="address" type="text" class="form-control" formControlName="address"
           placeholder="Street Address">
    <ua-display-validation-errors name='Street Address' [control]="accountForm.controls.address"
                                  [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="mb-3">
    <input id="city" type="text" class="form-control" formControlName="city"
           placeholder="City">
    <ua-display-validation-errors name='City' [control]="accountForm.controls.city"
                                  [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="row g-2">
    <div class="col-6">
      <select [class]="accountForm.controls.state.value === -1 ? 'text-muted' : ''" id="state"
              class="form-select" formControlName="state">
        <option value="-1" disabled>State</option>
        <option class="text-dark" *ngFor="let state of states" value="{{state.stateCode}}">
          {{state.stateCode}} - {{state.name}}
        </option>
      </select>
      <ua-display-validation-errors name='State' [control]="accountForm.controls.state"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
    <div class="col-6">
      <input id="zip" type="text" class="form-control" formControlName="zip"
             placeholder="Zip Code">
      <ua-display-validation-errors name='Zip Code' [control]="accountForm.controls.zip"
                                    [force]="formDirty">
      </ua-display-validation-errors>
    </div>
  </div>

  <div class="mt-5">
    <button type="submit" class="btn btn-primary w-100">Save</button>
  </div>

  <div class="my-4">
    <button type="button" class="btn btn-outline-primary w-100" (click)="cancel()">Cancel</button>
  </div>
</form>

